import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

type Variant = "primary" | "ghost" | "quiet";

/**
 * Ember is spent here and almost nowhere else. A section asks for at most one
 * primary action; everything else is a hairline ghost. That is the product's
 * ISA-101 rule applied to the marketing page.
 */
const base =
  "inline-flex items-center justify-center rounded font-display text-sm font-bold uppercase tracking-[0.08em] px-6 py-3.5 transition-colors duration-150 " +
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-ember focus-visible:ring-offset-2 focus-visible:ring-offset-ink";

const variants: Record<Variant, string> = {
  primary: "bg-ember text-ember-ink hover:bg-ember-deep",
  ghost: "border border-line/20 text-bone hover:border-line/40 hover:bg-panel/60",
  quiet: "text-bone-dim hover:text-bone",
};

export function Button({
  to,
  href,
  variant = "primary",
  className,
  children,
  ...rest
}: {
  to?: string;
  href?: string;
  variant?: Variant;
  className?: string;
  children: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const cls = cn(base, variants[variant], className);
  if (to) return <Link to={to} className={cls}>{children}</Link>;
  if (href) return <a href={href} className={cls}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
}
